import React from 'react';
import Notify from 'containers/Notify/Notify';
import TagModal from 'containers/Modals/TagModal/TagModal';
import ConfirmModal from 'containers/Modals/Confirm/Confirm';
import UserModal from 'containers/Modals/UserModal/UserModal';
import TaskModal from 'containers/Modals/TaskModal/TaskModal';
import ItemSKUModal from 'containers/Modals/Item/ItemSKUModal';
import AssetModal from 'containers/Modals/AssetModal/AssetModal';
import EmailModal from 'containers/Modals/EmailModal/EmailModal';
import PeopleModal from 'containers/Modals/PeopleModal/PeopleModal';
import StorageModal from 'containers/Modals/StorageModal/StorageModal';
import ItemCreatedModal from 'containers/Modals/Item/ItemCreatedModal';
import CompanyModal from 'containers/Modals/CompanyModal/CompanyModal';
import ItemQuantityModal from 'containers/Modals/Item/ItemQuantityModal';
import CategoryModal from 'containers/Modals/CategoryModal/CategoryModal';
import CustomerModal from 'containers/Modals/CustomerModal/CustomerModal';
import { SettingModal } from 'containers/Modals/SettingModal/SettingModal';
import WarehouseModal from 'containers/Modals/WarehouseModal/WarehouseModal';
import OrderInfoModal from 'containers/Modals/OrderInfoModal/OrderInfoModal';
import StorageListModal from 'containers/Modals/StorageListModal/StorageListModal';
import UserProfileModal from 'containers/Modals/UserProfileModal/UserProfileModal';
import AssignAssetModal from 'containers/Modals/AssignAssetModal/AssignAssetModal';
import WarehouseListModal from 'containers/Modals/WarehouseListModal/WarehouseListModal';
import AssignedAssetModal from 'containers/Modals/AssignedAssetModal/AssignedAssetModal';

function RootModal() {
  return (
    <>
      <Notify />
      <TagModal />
      <UserModal />
      <TaskModal />
      <EmailModal />
      <AssetModal />
      <PeopleModal />
      <ConfirmModal />
      <StorageModal />
      <CompanyModal />
      <SettingModal />
      <ItemSKUModal />
      <CustomerModal />
      <CategoryModal />
      <WarehouseModal />
      <OrderInfoModal />
      <ItemCreatedModal />
      <StorageListModal />
      <UserProfileModal />
      <AssignAssetModal />
      <ItemQuantityModal />
      <AssignedAssetModal />
      <WarehouseListModal />
    </>
  );
}

export default RootModal;
